import useUser from './useUser';

export const useCurrentOrg = () => useUser().currentOrganization;
